<script setup>
import { defineProps, ref, onMounted } from 'vue';
import OfSessionContactInformation from '@dk.onlinefundraising/onboarding-utils/src/components/OfSessionContactInformation.vue';
import OfUpgradeSelection from '@dk.onlinefundraising/onboarding-utils/src/components/OfUpgradeSelection.vue';
import requests from '../OfOnboardingRequests.js'
import { getBetalingsserviceStartDateService, filterContactData, validateContactData, filterMetaData, filterFormResult, filterServiceType, filterFormFields, filterQueryString, filterTransactionalData, filterCompletionChannel, filterTemporaryServiceType, filterValidateGatewayRequirements, formatDateToYMD } from '@dk.onlinefundraising/onboarding-utils/src/functions';
import { user } from '@/store';
import { toaster } from '@dk.onlinefundraising/vue-utils/src/helpers/OfToaster';

const props = defineProps({
    workflow: Object,
    campaign: Object,
    client: Object
})

// const subscriptionGuid = ref();

const contactDataFields = ref(props.workflow.contactDataFields ?? []);

const subscription = ref();
const agreement = ref();
const staticAgreement = ref();
const contact = ref();
const paymentMethod = ref();
const addOns = ref();
const product = ref({});
const loaded = ref(false);
const requestResponse = ref()
const sessionDelayCounter = ref();
const iframeGatewayUrl = ref();
const sessionStatus = ref();
const sessionCount = ref(0);
const onlyButton = ref();

const workflowMetaDataFields = props.workflow.metaDataFields ?? []
const campaignMetaDataFields = props.campaign.metaDataFields ?? []

const metaDataFields = ref(workflowMetaDataFields.concat(campaignMetaDataFields));

let interval;

function getSubscription(delay) {

    setTimeout(() => {

        const subscriptionGuid = new URLSearchParams(window.location.search).get('subscriptionGuid')

        requests.getSubscription(subscriptionGuid.trim(), props.campaign.merchantId).then((result) => {
            subscription.value = result;

            getAddOns();
            getAgreement();
            getContact();
            getPaymentMethod();
        })

    }, delay ? 1000 : 0)

}
function getAddOns() {
    requests.getAddOns(subscription.value.subscriptionGuid, props.campaign.merchantId).then((result) => {
        addOns.value = result;
    })
}
function getAgreement() {
    requests.getAgreement(subscription.value.agreementGuid, props.campaign.merchantId).then((result) => {
        agreement.value = result;
        staticAgreement.value = {...result};
    })
}
function getContact() {
    requests.getContact(subscription.value.contactGuid, props.campaign.merchantId).then((result) => {
        contact.value = result;

        if (contactDataFields.value){
            contactDataFields.value.map((field) => {
                if (contact.value[field.name]) {
                    field.value = contact.value[field.name];
                }
            })
        }

        loaded.value = true;

    })
}
function getPaymentMethod() {
    requests.getPaymentMethod(subscription.value.paymentMethodGuid, props.campaign.merchantId).then((result) => {
        paymentMethod.value = result;
    })
}
function initialiseUpgrade(serviceType) {


    //  Ensure session delay counter is enforced
    if (sessionDelayCounter.value > 0/* && !ignoreDelay*/) {

        toaster.error("Please wait one moment and try again.");
        return;
    } else {
        sessionDelayCounter.value = 10;

        interval = setInterval(() => {
            sessionDelayCounter.value = sessionDelayCounter.value - 1;

            if (sessionDelayCounter.value == 0) {
                clearInterval(interval);
            }
        }, 1000)

    }

    requestResponse.value = null;

    let request = {
        agencyId: user.value.agencyId,
        merchantId: props.client.merchantId,
        agreementData:
            agreement.value,

        subscriptionData: {
            subscriptionGuid: subscription.value.subscriptionGuid
        },
        paymentMethodData: {
            paymentMethodGuid: paymentMethod.value.paymentMethodGuid
        },
        contactData: {
            ...contact.value,
            msisdn: product.value.msisdn ?? contact.value.msisdn
        },
        userGuid: user.value.guid,
        campaignGuid: props.campaign.campaignGuid,
        workflowGuid: props.workflow.workflowGuid,
        serviceType: serviceType,
        externalLeadId: subscription.value.subscriptionGuid,
        completionChannel: "",
    }

    request = filterContactData(request, product.value, contactDataFields.value, contact.value.contactGuid);
    request = validateContactData(request, contactDataFields.value);
    request = filterMetaData(request, metaDataFields.value);

    request = filterServiceType(request, product.value, 'Upgrade');
    request = filterCompletionChannel(request, product.value);
    // request = filterLeadId(request, product.value);

    request = filterTransactionalData(request, product.value, props.client, subscription.value);
    request = filterFormResult(request, product.value, contactDataFields.value, user.value, props.client, staticAgreement.value, props.workflow);
    request = filterFormFields(request);
    request = filterQueryString(request);
    request = filterTemporaryServiceType(request);

    request = filterValidateGatewayRequirements(request, product.value);

    if (request.error) {
        toaster.error(request.error)
        return;
    }

    if (serviceType == 'AgreementUpdate') {
        requests.updateAgreement(request).then(result => {
            if (result) {
                sessionCount.value++

                requestResponse.value = {
                    message: 'The update was registered.',
                    color: 'green'
                }
            }

            getSubscription(true);

        });
    } else if (serviceType == 'CreateAddOn') {
        requests.createAddOn(request).then(result => {
            sessionCount.value++

            if (result) {

                requestResponse.value = {
                    message: 'The add-on was registered.',
                    color: 'green'
                }

                getSubscription(true);

            }
        });
    } else if (serviceType == 'ChangePaymentMethod') {
        requests.changePaymentMethod(request).then(result => {
            if (result) {
                sessionStatus.value = 'Processing';
                sessionCount.value++

                if (request.completionChannel == 'SMS') {
                    loadOnboardingSession(result.sessionGuid)
                } else {
                    loadPaymentSession(result.sessionGuid);
                }
            }
        });
    } else if (serviceType == 'SubscriptionHold') {
        requests.holdSubscription(request).then(result => {
            if (result) {
                sessionCount.value++

                requestResponse.value = {
                    message: 'Subscription paused',
                    color: 'green'
                }

                getSubscription(true);

            }
        });
    } else if (serviceType == 'SubscriptionSetExpiration') {
        requests.holdSubscription(request).then(result => {
            if (result) {
                sessionCount.value++

                request.subscriptionData.expiresAfterDate = formatDateToYMD(product.value.expiresAfterDate.startDate);
                request.subscriptionData.startDate = formatDateToYMD(new Date());

                requests.restartSubscription(request).then(result => {
                    if (result) {

                        requestResponse.value = {
                            message: 'Subscription expiration set',
                            color: 'green'
                        }

                        getSubscription(true);

                    }
                });
            }
        });
    } else if (serviceType == 'SubscriptionCancel') {
        requests.cancelSubscription(request).then(result => {
            if (result) {
                sessionCount.value++

                requestResponse.value = {
                    message: 'Subscription cancelled',
                    color: 'green'
                }

                getSubscription(true);

            }
        });
    } else if (serviceType == 'SubscriptionRestart') {
        requests.restartSubscription(request).then(result => {
            if (result) {
                sessionCount.value++

                requestResponse.value = {
                    message: 'Subscription restarted',
                    color: 'green'
                }

                getSubscription(true);

            }
        });
    }

}
let sessionInterval;
function loadPaymentSession(sessionGuid) {

    setTimeout(() => {
        getPaymentSession(sessionGuid);
        sessionInterval = setInterval(() => {
            getPaymentSession(sessionGuid);
        }, 3000)
    }, 500)

}
async function getPaymentSession(sessionGuid) {
    requests.getPaymentSession(sessionGuid, props.campaign.merchantId).then(session => {
        if (session){
            if (session.state == 'Failed') {
                requestResponse.value = {
                    message: 'Session failed to start.',
                    color: 'red'
                }
            }
            if (!iframeGatewayUrl.value) {
                iframeGatewayUrl.value = session.redirectToGatewayUrl;
            }

            if (session.state == 'Complete') {
                clearInterval(sessionInterval);
                requestResponse.value = {
                    message: 'Session complete, please proceed to the next lead',
                    color: 'green'
                }

                getSubscription();

            }

            sessionStatus.value = session.state;
        }
    });
}
function loadOnboardingSession(sessionGuid) {
    
    setTimeout(() => {
        getOnboardingSession(sessionGuid);
        sessionInterval = setInterval(() => {
            getOnboardingSession(sessionGuid);
        }, 3000)
    }, 500)

}
function getOnboardingSession(sessionGuid) {
    requests.getOnboardingSession(sessionGuid).then((session) => {
        sessionStatus.value = session.status;

        if (session.status == 'Completed') {
            clearInterval(sessionInterval);
            requestResponse.value = {
                message: 'Session complete, please proceed to the next lead',
                color: 'green'
            }
        } 
    })
}
function abortSession() {
    sessionStatus.value = null;
    requestResponse.value = null;
    iframeGatewayUrl.value = null;
    toaster.success('Aborted');
    clearInterval(sessionInterval);
}
onMounted(() => {
    getSubscription();

    getBetalingsserviceStartDateService();

    const onlyButtonParam = new URLSearchParams(window.location.search).get('onlyButton');
    onlyButton.value = onlyButtonParam == 'true' ? true : false;
})

</script>
<template>
    <form id="session-form" class="form-horizontal">

        <OfSessionContactInformation v-if="loaded" v-model:contactDataFields="contactDataFields"
            v-model:metaDataFields="metaDataFields" :workflow="workflow" :merchant="client" :only-button="onlyButton" collapsed />

        <OfUpgradeSelection v-if="agreement && subscription && subscription" v-model:product="product"
            :agreement="agreement" :static-agreement="staticAgreement" :subscription="subscription"
            :payment-method="paymentMethod" :add-ons="addOns" :upgrade-products="workflow.upgradeProducts"
            :workflow="workflow" :session-delay-counter="sessionDelayCounter" :request-response="requestResponse"
            :iframe-gateway-url="iframeGatewayUrl" :session-status="sessionStatus" :session-count="sessionCount" :only-button="onlyButton" :merchant="client"
            @initialise-upgrade="initialiseUpgrade" @abort-session="abortSession" />

    </form>

</template>
<style scoped>
form :deep(.message) {
    justify-content: center;
}

form :deep(.message i) {
    display: none;
}
</style>